export enum PulseVariant {
  control = "control",
  autoplay = "autoplay",
  manual = "manual",
}
